import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["button", "textarea"]

  initialize() {
    let buttons = $(this.buttonTarget).find("button");
    let input = $(this.buttonTarget).find("input");
    let textarea = $(this.textareaTarget);

    if(input[0].checked) {
      textarea.hide();
    }

    buttons[0].onclick = () => {
      textarea.find("textarea").val("");
      textarea.hide();
    }

    buttons[1].onclick = () => {
      textarea.show();
    }
  }
}